(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawfresh-bundle-selector')) {
    class PawfreshBundleSelector extends HTMLElement {
      constructor() {
        super();

        this.handlePresetChange = this.handlePresetChange.bind(this);

        this.handleProductSelect = this.handleProductSelect.bind(this);

        this.handleExternalPurchaseChange = this.handleExternalPurchaseChange.bind(this);
      }

      connectedCallback() {
        if (this.isConnectedToFlow) return;

        this.isConnectedToFlow = true;

        this.purchaseScope = this.closest('.shopify-section, dialog') || document;

        this.addEventListener('change', this.handlePresetChange);

        this.purchaseScope.addEventListener('shopify:product:select', this.handleProductSelect);

        this.purchaseScope.addEventListener('pawfresh:purchase-change', this.handleExternalPurchaseChange);

        queueMicrotask(() => {
          this.emitCurrentSelection();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handlePresetChange);

        this.purchaseScope?.removeEventListener('shopify:product:select', this.handleProductSelect);

        this.purchaseScope?.removeEventListener('pawfresh:purchase-change', this.handleExternalPurchaseChange);

        this.isConnectedToFlow = false;
      }

      handlePresetChange(event) {
        const input = event.target;

        if (!(input instanceof HTMLInputElement) || !input.matches('[data-preset-input]') || !input.checked) {
          return;
        }

        this.emitCurrentSelection();
      }

      async handleProductSelect(event) {
        const sourcePicker = event.target instanceof Element ? event.target.closest('variant-picker') : null;

        if (
          sourcePicker?.dataset.productId &&
          String(sourcePicker.dataset.productId) !== String(this.dataset.productId)
        ) {
          return;
        }

        try {
          const response = await event.promise;
          const detail = response?.detail;

          if (!detail?.html) return;

          if (detail.productId && String(detail.productId) !== String(this.dataset.productId)) {
            return;
          }

          const selector = `pawfresh-bundle-selector[data-block-id="${this.dataset.blockId}"]`;

          const updatedBlock = detail.html.querySelector(selector);

          if (!updatedBlock) return;

          const presetIsActive = this.updateFromRenderedBlock(updatedBlock);

          if (presetIsActive) {
            this.emitCurrentSelection();
          }
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn('[PawFresh bundle selector] Variant update failed:', error);
          }
        }
      }

      updateFromRenderedBlock(updatedBlock) {
        const currentSelectedInput = this.querySelector('[data-preset-input]:checked');

        const previousQuantity = currentSelectedInput instanceof HTMLInputElement ? currentSelectedInput.value : '';

        const presetWasActive = Boolean(previousQuantity);

        this.dataset.productId = updatedBlock.dataset.productId || this.dataset.productId;

        this.dataset.variantId = updatedBlock.dataset.variantId || '';

        this.dataset.variantLabel = updatedBlock.dataset.variantLabel || '';

        this.dataset.unitPrice = updatedBlock.dataset.unitPrice || '0';

        this.dataset.currencyCode = updatedBlock.dataset.currencyCode || '';

        this.dataset.variantAvailable = updatedBlock.dataset.variantAvailable || 'false';

        this.dataset.contentPrefix = updatedBlock.dataset.contentPrefix || '';

        const currentOptions = this.querySelector('.pf-bundle__options');

        const updatedOptions = updatedBlock.querySelector('.pf-bundle__options');

        if (!currentOptions || !updatedOptions) {
          return false;
        }

        /*
         * The quantities differ between the two meal sizes,
         * so replace the full preset list with the freshly
         * rendered list from Horizon's variant response.
         *
         * The change listener is attached to the parent custom
         * element, so the new radio inputs remain interactive.
         */
        currentOptions.innerHTML = updatedOptions.innerHTML;

        /*
         * When Step 4 custom quantity is active, there is no
         * checked preset. Keep the preset block inactive after
         * the meal variant changes.
         */
        if (!presetWasActive) {
          this.clearPresetSelection();
          return false;
        }

        /*
         * Preserve the previous quantity when it exists for the
         * newly selected meal size.
         *
         * 1 and 14 exist for both 100g and 200g.
         */
        let nextSelectedInput = this.querySelector(`[data-preset-input][value="${previousQuantity}"]:not(:disabled)`);

        /*
         * If the previous quantity is unavailable for the new
         * size, use that size's configured default selection.
         *
         * Examples:
         * 28 packs → switching from 100g to 200g
         * 7 packs  → switching from 200g to 100g
         */
        if (!(nextSelectedInput instanceof HTMLInputElement)) {
          nextSelectedInput = this.querySelector('[data-preset-input]:checked:not(:disabled)');
        }

        /*
         * Final fallback to the first available quantity.
         */
        if (!(nextSelectedInput instanceof HTMLInputElement)) {
          nextSelectedInput = this.querySelector('[data-preset-input]:not(:disabled)');
        }

        this.querySelectorAll('[data-preset-input]').forEach((input) => {
          if (input instanceof HTMLInputElement) {
            input.checked = input === nextSelectedInput;
          }
        });

        return nextSelectedInput instanceof HTMLInputElement;
      }

      clearPresetSelection() {
        this.querySelectorAll('[data-preset-input]').forEach((input) => {
          if (input instanceof HTMLInputElement) {
            input.checked = false;
          }
        });
      }

      handleExternalPurchaseChange(event) {
        if (event.target === this) return;

        const detail = event.detail || {};

        if (detail.sectionId && String(detail.sectionId) !== String(this.dataset.sectionId)) {
          return;
        }

        if (detail.productId && String(detail.productId) !== String(this.dataset.productId)) {
          return;
        }

        /*
         * Step 4 dispatches source: "custom".
         * When it becomes active, the Step 2 preset selection
         * must be visually and functionally cleared.
         */
        if (detail.source === 'custom') {
          this.clearPresetSelection();
        }
      }

      emitCurrentSelection() {
        const selectedInput = this.querySelector('[data-preset-input]:checked');

        if (!(selectedInput instanceof HTMLInputElement)) {
          return;
        }

        const selectedCard = selectedInput.closest('[data-preset-card]');

        if (!selectedCard) return;

        const quantity = Number(selectedInput.value || 1);
        const unitPrice = Number(this.dataset.unitPrice || 0);

        const totalPrice = Number(selectedCard.dataset.totalPrice || unitPrice * quantity);

        const presetTitle = selectedCard.querySelector('[data-preset-title]')?.textContent?.trim() || '';

        const packLabel =
          selectedCard
            .querySelector('[data-preset-pack]')
            ?.textContent?.replace(/^\s*·\s*/, '')
            .trim() || (quantity === 1 ? '1 Pack' : `${quantity} Packs`);

        this.dispatchEvent(
          new CustomEvent('pawfresh:purchase-change', {
            bubbles: true,
            composed: true,
            detail: {
              type: 'quantity',
              source: 'preset',
              sectionId: this.dataset.sectionId,
              productId: this.dataset.productId,
              variantId: this.dataset.variantId,
              variantLabel: this.dataset.variantLabel,
              variantAvailable: this.dataset.variantAvailable === 'true',
              quantity,
              unitPrice,
              totalPrice,
              presetKey: selectedCard.dataset.presetKey,
              presetTitle,
              packLabel,
              currencyCode: this.dataset.currencyCode,
            },
          })
        );
      }
    }

    customElements.define('pawfresh-bundle-selector', PawfreshBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-selector-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawfresh-custom-quantity')) {
    class PawfreshCustomQuantity extends HTMLElement {
      constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleProductSelect =
          this.handleProductSelect.bind(this);
        this.handleExternalPurchaseChange =
          this.handleExternalPurchaseChange.bind(this);
      }

      connectedCallback() {
        if (this.isConnectedToFlow) return;

        this.isConnectedToFlow = true;
        this.purchaseScope =
          this.closest('.shopify-section, dialog') || document;

        this.addEventListener('click', this.handleClick);
        this.addEventListener('input', this.handleInput);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('focusin', this.handleFocusIn);

        this.purchaseScope.addEventListener(
          'shopify:product:select',
          this.handleProductSelect
        );

        this.purchaseScope.addEventListener(
          'pawfresh:purchase-change',
          this.handleExternalPurchaseChange
        );

        this.synchroniseInterface();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('input', this.handleInput);
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('focusin', this.handleFocusIn);

        this.purchaseScope?.removeEventListener(
          'shopify:product:select',
          this.handleProductSelect
        );

        this.purchaseScope?.removeEventListener(
          'pawfresh:purchase-change',
          this.handleExternalPurchaseChange
        );

        this.isConnectedToFlow = false;
      }

      get quantityInput() {
        return this.querySelector('[data-quantity-input]');
      }

      get minusButton() {
        return this.querySelector('[data-quantity-minus]');
      }

      get plusButton() {
        return this.querySelector('[data-quantity-plus]');
      }

      get priceElement() {
        return this.querySelector('[data-custom-total-price]');
      }

      get customCard() {
        return this.querySelector('[data-custom-card]');
      }

      get minimum() {
        return Math.max(
          1,
          Number.parseInt(this.dataset.quantityMin || '1', 10) || 1
        );
      }

      get increment() {
        return Math.max(
          1,
          Number.parseInt(
            this.dataset.quantityIncrement || '1',
            10
          ) || 1
        );
      }

      get maximum() {
        const value = this.dataset.quantityMax;

        if (value === undefined || value === '') return null;

        const parsedValue = Number.parseInt(value, 10);

        return Number.isFinite(parsedValue) ? parsedValue : null;
      }

      get unitPrice() {
        return Number.parseInt(this.dataset.unitPrice || '0', 10) || 0;
      }

      get isAvailable() {
        return this.dataset.variantAvailable === 'true';
      }

      get isActive() {
        return this.dataset.active === 'true';
      }

      handleClick(event) {
        const target =
          event.target instanceof Element ? event.target : null;

        if (!target || !this.isAvailable) return;

        const minusButton = target.closest('[data-quantity-minus]');
        const plusButton = target.closest('[data-quantity-plus]');

        if (minusButton) {
          event.preventDefault();
          this.changeQuantity(-1);
          return;
        }

        if (plusButton) {
          event.preventDefault();
          this.changeQuantity(1);
          return;
        }

        if (
          target.closest('[data-quantity-input]') ||
          !target.closest('[data-custom-card]')
        ) {
          return;
        }

        this.activateCustomQuantity(true);
      }

      handleFocusIn(event) {
        if (
          event.target instanceof HTMLInputElement &&
          event.target.matches('[data-quantity-input]') &&
          this.isAvailable
        ) {
          this.activateCustomQuantity(true);
        }
      }

      handleInput(event) {
        const input = event.target;

        if (
          !(input instanceof HTMLInputElement) ||
          !input.matches('[data-quantity-input]') ||
          !this.isAvailable
        ) {
          return;
        }

        const cleanedValue = input.value.replace(/[^\d]/g, '');

        if (input.value !== cleanedValue) {
          input.value = cleanedValue;
        }

        if (cleanedValue === '') return;

        let quantity = Number.parseInt(cleanedValue, 10);

        if (!Number.isFinite(quantity)) return;

        quantity = Math.max(this.minimum, quantity);

        if (this.maximum !== null) {
          quantity = Math.min(this.maximum, quantity);
        }

        input.value = String(quantity);

        this.setActive(true);
        this.renderPrice(quantity);
        this.updateButtonStates(quantity);
        this.emitCustomSelection(quantity);
      }

      handleChange(event) {
        const input = event.target;

        if (
          !(input instanceof HTMLInputElement) ||
          !input.matches('[data-quantity-input]')
        ) {
          return;
        }

        const quantity = this.normaliseQuantity(input.value);

        input.value = String(quantity);

        this.setActive(true);
        this.renderPrice(quantity);
        this.updateButtonStates(quantity);
        this.emitCustomSelection(quantity);
      }

      handleKeydown(event) {
        const target =
          event.target instanceof Element ? event.target : null;

        if (
          !target ||
          !target.matches('[data-custom-card]') ||
          !this.isAvailable
        ) {
          return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        this.activateCustomQuantity(true);
      }

      changeQuantity(direction) {
        if (!this.isAvailable) return;

        const currentQuantity = this.normaliseQuantity(
          this.quantityInput?.value
        );

        const proposedQuantity =
          currentQuantity + this.increment * direction;

        const newQuantity = this.normaliseQuantity(proposedQuantity);

        if (this.quantityInput instanceof HTMLInputElement) {
          this.quantityInput.value = String(newQuantity);
        }

        this.setActive(true);
        this.renderPrice(newQuantity);
        this.updateButtonStates(newQuantity);
        this.emitCustomSelection(newQuantity);
      }

      activateCustomQuantity(shouldEmit) {
        if (!this.isAvailable) return;

        const quantity = this.normaliseQuantity(
          this.quantityInput?.value
        );

        if (this.quantityInput instanceof HTMLInputElement) {
          this.quantityInput.value = String(quantity);
        }

        this.setActive(true);
        this.renderPrice(quantity);
        this.updateButtonStates(quantity);

        if (shouldEmit) {
          this.emitCustomSelection(quantity);
        }
      }

      setActive(active) {
        this.dataset.active = active ? 'true' : 'false';

        this.customCard?.setAttribute(
          'aria-checked',
          active ? 'true' : 'false'
        );
      }

      normaliseQuantity(value) {
        let quantity = Number.parseInt(String(value || ''), 10);

        if (!Number.isFinite(quantity)) {
          quantity = this.minimum;
        }

        quantity = Math.max(this.minimum, quantity);

        const difference = quantity - this.minimum;
        const remainder = difference % this.increment;

        if (remainder !== 0) {
          quantity -= remainder;
        }

        quantity = Math.max(this.minimum, quantity);

        if (this.maximum !== null) {
          quantity = Math.min(this.maximum, quantity);

          const maximumDifference = quantity - this.minimum;
          const maximumRemainder =
            maximumDifference % this.increment;

          if (maximumRemainder !== 0) {
            quantity -= maximumRemainder;
          }
        }

        return Math.max(this.minimum, quantity);
      }

      synchroniseInterface() {
        const quantity = this.normaliseQuantity(
          this.quantityInput?.value
        );

        if (this.quantityInput instanceof HTMLInputElement) {
          this.quantityInput.value = String(quantity);
          this.quantityInput.disabled = !this.isAvailable;
        }

        if (this.minusButton instanceof HTMLButtonElement) {
          this.minusButton.disabled = !this.isAvailable;
        }

        if (this.plusButton instanceof HTMLButtonElement) {
          this.plusButton.disabled = !this.isAvailable;
        }

        this.customCard?.setAttribute(
          'aria-disabled',
          this.isAvailable ? 'false' : 'true'
        );

        this.customCard?.setAttribute(
          'tabindex',
          this.isAvailable ? '0' : '-1'
        );

        this.renderPrice(quantity);
        this.updateButtonStates(quantity);
      }

      updateButtonStates(quantity) {
        if (this.minusButton instanceof HTMLButtonElement) {
          this.minusButton.disabled =
            !this.isAvailable || quantity <= this.minimum;
        }

        if (this.plusButton instanceof HTMLButtonElement) {
          this.plusButton.disabled =
            !this.isAvailable ||
            (this.maximum !== null && quantity >= this.maximum);
        }
      }

      renderPrice(quantity) {
        const totalPrice = this.unitPrice * quantity;

        if (this.priceElement) {
          this.priceElement.textContent =
            this.formatMoney(totalPrice);

          this.priceElement.dataset.totalPrice =
            String(totalPrice);
        }
      }

      formatMoney(cents) {
        const format =
          this.dataset.moneyFormat || '${{amount}}';

        const placeholderMatch = format.match(
          /\{\{\s*(\w+)\s*\}\}/
        );

        if (!placeholderMatch) {
          return this.formatWithDelimiters(
            cents,
            2,
            ',',
            '.'
          );
        }

        const placeholder = placeholderMatch[1];
        let formattedValue;

        switch (placeholder) {
          case 'amount_no_decimals':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              ',',
              '.'
            );
            break;

          case 'amount_with_comma_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              '.',
              ','
            );
            break;

          case 'amount_no_decimals_with_comma_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              '.',
              ','
            );
            break;

          case 'amount_with_space_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              ' ',
              ','
            );
            break;

          case 'amount_no_decimals_with_space_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              ' ',
              ','
            );
            break;

          case 'amount':
          default:
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              ',',
              '.'
            );
            break;
        }

        return format.replace(
          placeholderMatch[0],
          formattedValue
        );
      }

      formatWithDelimiters(
        cents,
        precision,
        thousandsSeparator,
        decimalSeparator
      ) {
        const amount = Number(cents || 0) / 100;
        const fixedAmount = amount.toFixed(precision);
        const parts = fixedAmount.split('.');

        parts[0] = parts[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          thousandsSeparator
        );

        return precision > 0
          ? `${parts[0]}${decimalSeparator}${parts[1]}`
          : parts[0];
      }

      emitCustomSelection(quantity) {
        if (!this.isActive || !this.isAvailable) return;

        const totalPrice = this.unitPrice * quantity;
        const packLabel =
          quantity === 1 ? '1 Pack' : `${quantity} Packs`;

        this.dispatchEvent(
          new CustomEvent('pawfresh:purchase-change', {
            bubbles: true,
            composed: true,
            detail: {
              type: 'quantity',
              source: 'custom',
              sectionId: this.dataset.sectionId,
              productId: this.dataset.productId,
              variantId: this.dataset.variantId,
              variantLabel: this.dataset.variantLabel,
              variantAvailable: this.isAvailable,
              quantity,
              unitPrice: this.unitPrice,
              totalPrice,
              presetKey: null,
              presetTitle: '',
              packLabel,
              currencyCode: this.dataset.currencyCode
            }
          })
        );
      }

      handleExternalPurchaseChange(event) {
        if (event.target === this) return;

        const detail = event.detail || {};

        if (
          detail.sectionId &&
          String(detail.sectionId) !==
            String(this.dataset.sectionId)
        ) {
          return;
        }

        if (
          detail.productId &&
          String(detail.productId) !==
            String(this.dataset.productId)
        ) {
          return;
        }

        if (detail.source === 'preset') {
          this.setActive(false);
        }
      }

      async handleProductSelect(event) {
        const sourcePicker =
          event.target instanceof Element
            ? event.target.closest('variant-picker')
            : null;

        if (
          sourcePicker?.dataset.productId &&
          String(sourcePicker.dataset.productId) !==
            String(this.dataset.productId)
        ) {
          return;
        }

        try {
          const response = await event.promise;
          const detail = response?.detail;

          if (!detail?.html) return;

          if (
            detail.productId &&
            String(detail.productId) !==
              String(this.dataset.productId)
          ) {
            return;
          }

          const selector =
            `pawfresh-custom-quantity[data-block-id="${this.dataset.blockId}"]`;

          const updatedBlock =
            detail.html.querySelector(selector);

          if (!updatedBlock) return;

          this.updateFromRenderedBlock(updatedBlock);

          const quantity = this.normaliseQuantity(
            this.quantityInput?.value
          );

          if (this.quantityInput instanceof HTMLInputElement) {
            this.quantityInput.value = String(quantity);
          }

          this.synchroniseInterface();

          if (this.isActive && this.isAvailable) {
            this.emitCustomSelection(quantity);
          }
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn(
              '[PawFresh custom quantity] Variant update failed:',
              error
            );
          }
        }
      }

      updateFromRenderedBlock(updatedBlock) {
        this.dataset.productId =
          updatedBlock.dataset.productId ||
          this.dataset.productId;

        this.dataset.variantId =
          updatedBlock.dataset.variantId || '';

        this.dataset.variantLabel =
          updatedBlock.dataset.variantLabel || '';

        this.dataset.unitPrice =
          updatedBlock.dataset.unitPrice || '0';

        this.dataset.currencyCode =
          updatedBlock.dataset.currencyCode || '';

        this.dataset.moneyFormat =
          updatedBlock.dataset.moneyFormat ||
          this.dataset.moneyFormat ||
          '${{amount}}';

        this.dataset.variantAvailable =
          updatedBlock.dataset.variantAvailable || 'false';

        this.dataset.quantityMin =
          updatedBlock.dataset.quantityMin || '1';

        this.dataset.quantityIncrement =
          updatedBlock.dataset.quantityIncrement || '1';

        this.dataset.quantityMax =
          updatedBlock.dataset.quantityMax || '';
      }
    }

    customElements.define(
      'pawfresh-custom-quantity',
      PawfreshCustomQuantity
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["purchase-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawfresh-purchase-submit')) {
    class PawfreshPurchaseSubmit extends HTMLElement {
      constructor() {
        super();

        this.state = {
          source: 'preset',
          quantity: 1,
          presetTitle: '',
          packLabel: '1 Pack',
          variantId: '',
          variantLabel: '',
          sellingPlanId: ''
        };

        this.pendingTimers = [];

        this.handlePurchaseChange =
          this.handlePurchaseChange.bind(this);

        this.handleProductSelect =
          this.handleProductSelect.bind(this);

        this.handleAppstlePlanSelected =
          this.handleAppstlePlanSelected.bind(this);

        this.handleAppstlePlanDeselected =
          this.handleAppstlePlanDeselected.bind(this);

        this.handleAppstlePlanChanged =
          this.handleAppstlePlanChanged.bind(this);

        this.handleScopedInputChange =
          this.handleScopedInputChange.bind(this);

        this.handleMutation =
          this.handleMutation.bind(this);

        this.handleFormData =
          this.handleFormData.bind(this);

        this.handleFormSubmit =
          this.handleFormSubmit.bind(this);
      }

      connectedCallback() {
        if (this.isConnectedToFlow) return;

        this.isConnectedToFlow = true;

        this.purchaseScope =
          this.closest('.shopify-section, dialog') || document;

        this.state.variantId = this.dataset.variantId || '';
        this.state.variantLabel = this.dataset.variantLabel || '';
        this.state.sellingPlanId =
          this.normaliseSellingPlanId(
            this.dataset.initialSellingPlan || ''
          );

        this.purchaseScope.addEventListener(
          'pawfresh:purchase-change',
          this.handlePurchaseChange
        );

        this.purchaseScope.addEventListener(
          'shopify:product:select',
          this.handleProductSelect
        );

        this.purchaseScope.addEventListener(
          'change',
          this.handleScopedInputChange,
          true
        );

        this.purchaseScope.addEventListener(
          'input',
          this.handleScopedInputChange,
          true
        );

        document.addEventListener(
          'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
          this.handleAppstlePlanSelected
        );

        document.addEventListener(
          'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
          this.handleAppstlePlanDeselected
        );

        document.addEventListener(
          'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
          this.handleAppstlePlanChanged
        );

        this.form?.addEventListener(
          'formdata',
          this.handleFormData
        );

        this.form?.addEventListener(
          'submit',
          this.handleFormSubmit,
          true
        );

        this.mutationObserver = new MutationObserver(
          this.handleMutation
        );

        this.mutationObserver.observe(this.purchaseScope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'value']
        });

        this.hydrateQuantityFromBlocks();
        this.render();

        this.schedule(() => {
          this.hydrateQuantityFromBlocks();
          this.syncSellingPlanFromAppstle(true);
          this.render();
        }, 0);

        this.schedule(() => {
          this.syncSellingPlanFromAppstle(true);
        }, 300);

        this.schedule(() => {
          this.syncSellingPlanFromAppstle(true);
        }, 900);
      }

      disconnectedCallback() {
        this.purchaseScope?.removeEventListener(
          'pawfresh:purchase-change',
          this.handlePurchaseChange
        );

        this.purchaseScope?.removeEventListener(
          'shopify:product:select',
          this.handleProductSelect
        );

        this.purchaseScope?.removeEventListener(
          'change',
          this.handleScopedInputChange,
          true
        );

        this.purchaseScope?.removeEventListener(
          'input',
          this.handleScopedInputChange,
          true
        );

        document.removeEventListener(
          'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
          this.handleAppstlePlanSelected
        );

        document.removeEventListener(
          'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
          this.handleAppstlePlanDeselected
        );

        document.removeEventListener(
          'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
          this.handleAppstlePlanChanged
        );

        this.form?.removeEventListener(
          'formdata',
          this.handleFormData
        );

        this.form?.removeEventListener(
          'submit',
          this.handleFormSubmit,
          true
        );

        this.mutationObserver?.disconnect();

        this.pendingTimers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        this.pendingTimers = [];
        this.isConnectedToFlow = false;
      }

      get form() {
        return this.querySelector('form');
      }

      get productFormComponent() {
        return this.querySelector('product-form-component');
      }

      get variantInput() {
        return this.querySelector('[data-pf-variant-input]');
      }

      get quantityInput() {
        return this.querySelector('[data-pf-quantity-input]');
      }

      get sellingPlanInput() {
        return this.querySelector(
          '[data-pf-selling-plan-input]'
        );
      }

      get summaryElement() {
        return this.querySelector('[data-pf-selection]');
      }

      get totalElement() {
        return this.querySelector('[data-pf-total]');
      }

      get submitButton() {
        return this.querySelector('[data-pf-submit-button]');
      }

      get buttonTextElement() {
        return this.querySelector('[data-pf-button-text]');
      }

      get errorElement() {
        return this.querySelector('[data-pf-error]');
      }

      get errorTextElement() {
        return this.querySelector('[data-pf-error-text]');
      }

      get purchaseData() {
        const script = this.querySelector(
          '[data-pf-purchase-data]'
        );

        if (!script?.textContent) {
          return {
            productId: this.dataset.productId,
            requiresSellingPlan: false,
            variants: []
          };
        }

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.warn(
            '[PawFresh purchase submit] Product data could not be parsed.',
            error
          );

          return {
            productId: this.dataset.productId,
            requiresSellingPlan: false,
            variants: []
          };
        }
      }

      get currentVariant() {
        const data = this.purchaseData;

        return (
          data.variants?.find(
            (variant) =>
              String(variant.id) === String(this.state.variantId)
          ) || null
        );
      }

      get selectedAllocation() {
        const variant = this.currentVariant;

        if (!variant || !this.state.sellingPlanId) return null;

        return (
          variant.sellingPlans?.find(
            (plan) =>
              String(plan.id) ===
              String(this.state.sellingPlanId)
          ) || null
        );
      }

      schedule(callback, delay) {
        const timer = window.setTimeout(() => {
          callback();

          const timerIndex = this.pendingTimers.indexOf(timer);

          if (timerIndex !== -1) {
            this.pendingTimers.splice(timerIndex, 1);
          }
        }, delay);

        this.pendingTimers.push(timer);
      }

      hydrateQuantityFromBlocks() {
        const customBlock = this.purchaseScope.querySelector(
          `pawfresh-custom-quantity[data-product-id="${this.dataset.productId}"][data-active="true"]`
        );

        if (customBlock) {
          const input = customBlock.querySelector(
            '[data-quantity-input]'
          );

          const quantity = Number.parseInt(
            input?.value || '1',
            10
          );

          this.state.source = 'custom';
          this.state.quantity =
            Number.isFinite(quantity) && quantity > 0
              ? quantity
              : 1;
          this.state.presetTitle = '';
          this.state.packLabel =
            this.createPackLabel(this.state.quantity);

          return;
        }

        const presetBlock = this.purchaseScope.querySelector(
          `pawfresh-bundle-selector[data-product-id="${this.dataset.productId}"]`
        );

        const checkedPreset = presetBlock?.querySelector(
          '[data-preset-input]:checked'
        );

        if (!(checkedPreset instanceof HTMLInputElement)) return;

        const presetCard = checkedPreset.closest(
          '[data-preset-card]'
        );

        const quantity = Number.parseInt(
          checkedPreset.value || '1',
          10
        );

        this.state.source = 'preset';
        this.state.quantity =
          Number.isFinite(quantity) && quantity > 0
            ? quantity
            : 1;

        this.state.presetTitle =
          presetCard
            ?.querySelector('[data-preset-title]')
            ?.textContent?.trim() || '';

        this.state.packLabel =
          presetCard
            ?.querySelector('[data-preset-pack]')
            ?.textContent?.replace(/^·\s*/, '')
            .trim() ||
          this.createPackLabel(this.state.quantity);
      }

      handlePurchaseChange(event) {
        if (event.target === this) return;

        const detail = event.detail || {};

        if (detail.type !== 'quantity') return;

        if (
          detail.sectionId &&
          String(detail.sectionId) !==
            String(this.dataset.sectionId)
        ) {
          return;
        }

        if (
          detail.productId &&
          String(detail.productId) !==
            String(this.dataset.productId)
        ) {
          return;
        }

        const quantity = Number.parseInt(
          String(detail.quantity || 1),
          10
        );

        this.state.source =
          detail.source === 'custom' ? 'custom' : 'preset';

        this.state.quantity =
          Number.isFinite(quantity) && quantity > 0
            ? quantity
            : 1;

        this.state.presetTitle =
          this.state.source === 'preset'
            ? String(detail.presetTitle || '')
            : '';

        this.state.packLabel =
          String(detail.packLabel || '') ||
          this.createPackLabel(this.state.quantity);

        if (detail.variantId) {
          this.state.variantId = String(detail.variantId);
        }

        if (detail.variantLabel) {
          this.state.variantLabel =
            String(detail.variantLabel);
        }

        this.render();
      }

      async handleProductSelect(event) {
        const sourcePicker =
          event.target instanceof Element
            ? event.target.closest('variant-picker')
            : null;

        if (
          sourcePicker?.dataset.productId &&
          String(sourcePicker.dataset.productId) !==
            String(this.dataset.productId)
        ) {
          return;
        }

        try {
          const response = await event.promise;
          const detail = response?.detail;

          if (!detail?.html) return;

          if (
            detail.productId &&
            String(detail.productId) !==
              String(this.dataset.productId)
          ) {
            return;
          }

          const selector =
            `pawfresh-purchase-submit[data-block-id="${this.dataset.blockId}"]`;

          const updatedBlock =
            detail.html.querySelector(selector);

          if (!updatedBlock) return;

          this.updateFromRenderedBlock(updatedBlock);
          this.render();

          requestAnimationFrame(() => {
            this.render();
          });

          this.schedule(() => {
            this.syncSellingPlanFromAppstle(true);
            this.render();
          }, 100);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn(
              '[PawFresh purchase submit] Variant update failed.',
              error
            );
          }
        }
      }

      updateFromRenderedBlock(updatedBlock) {
        this.dataset.productId =
          updatedBlock.dataset.productId ||
          this.dataset.productId;

        this.dataset.variantId =
          updatedBlock.dataset.variantId || '';

        this.dataset.variantLabel =
          updatedBlock.dataset.variantLabel || '';

        this.dataset.requiresSellingPlan =
          updatedBlock.dataset.requiresSellingPlan || 'false';

        this.state.variantId = this.dataset.variantId;
        this.state.variantLabel =
          this.dataset.variantLabel;

        const currentDataScript = this.querySelector(
          '[data-pf-purchase-data]'
        );

        const updatedDataScript = updatedBlock.querySelector(
          '[data-pf-purchase-data]'
        );

        if (currentDataScript && updatedDataScript) {
          currentDataScript.textContent =
            updatedDataScript.textContent;
        }
      }

      handleAppstlePlanSelected() {
        this.schedule(() => {
          this.syncSellingPlanFromAppstle(true);
        }, 0);
      }

      handleAppstlePlanDeselected() {
        this.setSellingPlan('');
      }

      handleAppstlePlanChanged(event) {
        let selectedPlanId = event.detail;

        if (
          selectedPlanId &&
          typeof selectedPlanId === 'object'
        ) {
          selectedPlanId =
            selectedPlanId.sellingPlanId ||
            selectedPlanId.selling_plan_id ||
            selectedPlanId.id ||
            selectedPlanId.value ||
            '';
        }

        const normalisedId =
          this.normaliseSellingPlanId(selectedPlanId);

        if (normalisedId) {
          this.setSellingPlan(normalisedId);
        } else {
          this.schedule(() => {
            this.syncSellingPlanFromAppstle(true);
          }, 0);
        }
      }

      handleScopedInputChange(event) {
        const target =
          event.target instanceof Element
            ? event.target
            : null;

        if (!target) return;

        const appstleWidget = target.closest(
          '.appstle_sub_widget'
        );

        if (!appstleWidget) return;

        if (
          target.matches(
            'input[name="selling_plan"], select[name="selling_plan"]'
          ) ||
          target.closest(
            'input[name="selling_plan"], select[name="selling_plan"]'
          )
        ) {
          this.schedule(() => {
            this.syncSellingPlanFromAppstle(true);
          }, 0);
        }
      }

      handleMutation(mutations) {
        const appstleChanged = mutations.some((mutation) => {
          const mutationTarget =
            mutation.target instanceof Element
              ? mutation.target
              : mutation.target.parentElement;

          if (
            mutationTarget?.closest?.('.appstle_sub_widget')
          ) {
            return true;
          }

          return Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;

            return (
              node.matches('.appstle_sub_widget') ||
              Boolean(
                node.querySelector('.appstle_sub_widget')
              )
            );
          });
        });

        if (!appstleChanged) return;

        this.schedule(() => {
          this.syncSellingPlanFromAppstle(true);
        }, 0);
      }

      syncSellingPlanFromAppstle(allowEmpty) {
        const appstleWidget =
          this.purchaseScope.querySelector(
            '.appstle_sub_widget'
          );

        if (!appstleWidget) return;

        const checkedInput = appstleWidget.querySelector(
          'input[name="selling_plan"]:checked'
        );

        const selectedDropdown = appstleWidget.querySelector(
          'select[name="selling_plan"]'
        );

        const hiddenInput = appstleWidget.querySelector(
          'input[name="selling_plan"][type="hidden"]'
        );

        const selectedValue =
          checkedInput?.value ||
          selectedDropdown?.value ||
          hiddenInput?.value ||
          '';

        const sellingPlanId =
          this.normaliseSellingPlanId(selectedValue);

        if (sellingPlanId || allowEmpty) {
          this.setSellingPlan(sellingPlanId);
        }
      }

      normaliseSellingPlanId(value) {
        const stringValue = String(value || '').trim();

        if (!/^\d+$/.test(stringValue)) return '';

        return stringValue;
      }

      setSellingPlan(sellingPlanId) {
        this.state.sellingPlanId =
          this.normaliseSellingPlanId(sellingPlanId);

        this.render();
      }

      createPackLabel(quantity) {
        return quantity === 1
          ? '1 Pack'
          : `${quantity} Packs`;
      }

      getUnitPrice() {
        const variant = this.currentVariant;

        if (!variant) return 0;

        if (this.state.sellingPlanId) {
          const allocation = this.selectedAllocation;

          if (allocation) {
            return Number(allocation.price || 0);
          }
        }

        return Number(variant.price || 0);
      }

      getSummaryTitle() {
        const quantityLabel = (
  this.state.packLabel ||
  this.createPackLabel(this.state.quantity)
)
  .replace(/^\s*·\s*/, '')
  .trim();

        const variantLabel =
          this.currentVariant?.label ||
          this.state.variantLabel ||
          '';

        let title;

        if (
          this.state.source === 'preset' &&
          this.state.presetTitle
        ) {
          title = `${this.state.presetTitle} · ${quantityLabel}`;
        } else {
          title = quantityLabel;
        }

        if (variantLabel) {
          title += ` (${variantLabel})`;
        }

        return title;
      }

      getValidation() {
        const variant = this.currentVariant;
        const quantity = Number(this.state.quantity || 1);

        if (!variant) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.unavailableLabel ||
              'Unavailable',
            message: 'This product option is unavailable.'
          };
        }

        if (!variant.available) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.soldOutLabel ||
              'Sold out',
            message: 'This product option is currently sold out.'
          };
        }

        const quantityRule = variant.quantityRule || {};
        const minimum = Number(quantityRule.min || 1);
        const increment = Number(quantityRule.increment || 1);
        const maximum =
          quantityRule.max === null
            ? null
            : Number(quantityRule.max);

        if (quantity < minimum) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.defaultLabel ||
              'Add To Cart',
            message: `The minimum quantity is ${minimum}.`
          };
        }

        if ((quantity - minimum) % increment !== 0) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.defaultLabel ||
              'Add To Cart',
            message: `Quantity must increase in steps of ${increment}.`
          };
        }

        const cartQuantity = Number(
          variant.cartQuantity || 0
        );

        if (
          maximum !== null &&
          quantity + cartQuantity > maximum
        ) {
          const availableQuantity = Math.max(
            0,
            maximum - cartQuantity
          );

          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.defaultLabel ||
              'Add To Cart',
            message:
              availableQuantity > 0
                ? `You can add up to ${availableQuantity} more.`
                : 'The maximum quantity is already in your cart.'
          };
        }

        const requiresSellingPlan =
          this.purchaseData.requiresSellingPlan === true ||
          this.dataset.requiresSellingPlan === 'true';

        if (
          requiresSellingPlan &&
          !this.state.sellingPlanId
        ) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.choosePlanLabel ||
              'Choose a plan',
            message:
              'Choose a subscription option before adding this product.'
          };
        }

        if (
          this.state.sellingPlanId &&
          !this.selectedAllocation
        ) {
          return {
            valid: false,
            buttonLabel:
              this.submitButton?.dataset.invalidPlanLabel ||
              'Choose another plan',
            message:
              'This subscription option is unavailable for the selected meal size.'
          };
        }

        return {
          valid: true,
          buttonLabel:
            this.submitButton?.dataset.defaultLabel ||
            'Add To Cart',
          message: ''
        };
      }

      render() {
        const variant = this.currentVariant;

        if (variant) {
          this.state.variantId = String(variant.id);
          this.state.variantLabel =
            String(variant.label || '');
        }

        this.state.quantity = Math.max(
          1,
          Number.parseInt(
            String(this.state.quantity || 1),
            10
          ) || 1
        );

        const unitPrice = this.getUnitPrice();
        const totalPrice =
          unitPrice * this.state.quantity;

        if (this.summaryElement) {
          this.summaryElement.textContent =
            this.getSummaryTitle();
        }

        if (this.totalElement) {
          this.totalElement.textContent =
            this.formatMoney(totalPrice);

          this.totalElement.dataset.totalPrice =
            String(totalPrice);
        }

        if (this.variantInput instanceof HTMLInputElement) {
          this.variantInput.value =
            String(this.state.variantId || '');
        }

        if (this.quantityInput instanceof HTMLInputElement) {
          this.quantityInput.value =
            String(this.state.quantity);
        }

        if (
          this.sellingPlanInput instanceof HTMLInputElement
        ) {
          this.sellingPlanInput.value =
            this.state.sellingPlanId;
        }

        if (this.productFormComponent) {
          this.productFormComponent.dataset.quantityDefault =
            String(this.state.quantity);

          this.productFormComponent.dataset.productId =
            String(this.dataset.productId);
        }

        const validation = this.getValidation();

        if (this.submitButton instanceof HTMLButtonElement) {
          this.submitButton.disabled = !validation.valid;
          this.submitButton.setAttribute(
            'aria-disabled',
            validation.valid ? 'false' : 'true'
          );
        }

        if (this.buttonTextElement) {
          this.buttonTextElement.textContent =
            validation.buttonLabel;
        }

        if (validation.message) {
          this.showError(validation.message);
        } else {
          this.hideError();
        }
      }

      handleFormData(event) {
        const formData = event.formData;

        formData.set(
          'id',
          String(this.state.variantId || '')
        );

        formData.set(
          'quantity',
          String(this.state.quantity || 1)
        );

        if (this.state.sellingPlanId) {
          formData.set(
            'selling_plan',
            this.state.sellingPlanId
          );
        } else {
          formData.delete('selling_plan');
        }
      }

      handleFormSubmit(event) {
        this.syncSellingPlanFromAppstle(true);
        this.render();

        const validation = this.getValidation();

        if (validation.valid) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        this.showError(validation.message);
      }

      showError(message) {
        if (!this.errorElement || !this.errorTextElement) return;

        this.errorTextElement.textContent = message;
        this.errorElement.classList.remove('hidden');
      }

      hideError() {
        if (!this.errorElement || !this.errorTextElement) return;

        this.errorTextElement.textContent = '';
        this.errorElement.classList.add('hidden');
      }

      formatMoney(cents) {
        const format =
          this.dataset.moneyFormat || '${{amount}}';

        const placeholderMatch = format.match(
          /\{\{\s*(\w+)\s*\}\}/
        );

        if (!placeholderMatch) {
          return this.formatWithDelimiters(
            cents,
            2,
            ',',
            '.'
          );
        }

        const placeholder = placeholderMatch[1];
        let formattedValue;

        switch (placeholder) {
          case 'amount_no_decimals':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              ',',
              '.'
            );
            break;

          case 'amount_with_comma_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              '.',
              ','
            );
            break;

          case 'amount_no_decimals_with_comma_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              '.',
              ','
            );
            break;

          case 'amount_with_space_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              ' ',
              ','
            );
            break;

          case 'amount_no_decimals_with_space_separator':
            formattedValue = this.formatWithDelimiters(
              cents,
              0,
              ' ',
              ','
            );
            break;

          case 'amount':
          default:
            formattedValue = this.formatWithDelimiters(
              cents,
              2,
              ',',
              '.'
            );
            break;
        }

        return format.replace(
          placeholderMatch[0],
          formattedValue
        );
      }

      formatWithDelimiters(
        cents,
        precision,
        thousandsSeparator,
        decimalSeparator
      ) {
        const amount = Number(cents || 0) / 100;
        const fixedAmount = amount.toFixed(precision);
        const parts = fixedAmount.split('.');

        parts[0] = parts[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          thousandsSeparator
        );

        return precision > 0
          ? `${parts[0]}${decimalSeparator}${parts[1]}`
          : parts[0];
      }
    }

    customElements.define(
      'pawfresh-purchase-submit',
      PawfreshPurchaseSubmit
    );
  }
  } catch(e) { console.error(e); }
})();

})();
